import React, { useState } from 'react';
import { Nav, Accordion } from 'react-bootstrap';
import { FaTruck, FaTools, FaClipboardList, FaExchangeAlt, FaCheckCircle } from 'react-icons/fa';
import './style.css'; // Giữ lại nếu có các điều chỉnh CSS tổng thể khác

const NavbarComponent = ({ setComponentDuocChon, isSidebarOpen, toggleSidebar }) => {
  const [activeLink, setActiveLink] = useState('nhapThongTin'); // Quản lý trạng thái active của link

  // Xử lý khi chọn link trên sidebar và ẩn sidebar khi chọn
  const handleLinkClick = (component) => {
    setActiveLink(component);
    setComponentDuocChon(component);

    // Chỉ ẩn sidebar trên mobile sau khi chọn một menu
    if (window.innerWidth <= 768) {
      toggleSidebar(); // Ẩn sidebar sau khi chọn một menu trên mobile
    }
  };

  return (
    <>
      {/* Sidebar container */}
      <div
        id="navbar-sidebar"
        className={`bg-white vh-100 p-1 pt-3 border-end shadow-sm ${isSidebarOpen ? 'show' : ''}`}
        style={{
          width: window.innerWidth > 768 ? '16.67%' : isSidebarOpen ? '60%' : '0', // Sidebar luôn hiển thị trên desktop (2/12), toggle trên mobile (60%)
          height: '100vh',
          position: window.innerWidth > 768 ? 'fixed' : 'absolute', // Fixed trên desktop, absolute trên mobile
          top: '80px', // Đẩy xuống dưới header
          left: 0,
          zIndex: 999, // Đảm bảo sidebar luôn trên cùng khi mở
          transition: 'transform 0.4s ease, opacity 0.4s ease', // Hiệu ứng khi mở/đóng
          transform: isSidebarOpen || window.innerWidth > 768 ? 'translateX(0)' : 'translateX(-100%)', // Ẩn/Hiện bằng transform
          opacity: isSidebarOpen || window.innerWidth > 768 ? 1 : 0,
        }}
      >
        <Accordion defaultActiveKey="0" flush className="flex-grow-1">
          {/* Accordion Item 1 */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Nhập Thông Tin</span>
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <Nav className="flex-column">
                <Nav.Link
                  className={`sidebar-link ${activeLink === 'nhapThongTin' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('nhapThongTin')}
                  style={{
                    color: activeLink === 'nhapThongTin' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'nhapThongTin' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaTruck className="me-2" /> Nhập thông tin chuyến xe
                </Nav.Link>
                <Nav.Link
                  className={`sidebar-link ${activeLink === 'xemThongTin' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('xemThongTin')}
                  style={{
                    color: activeLink === 'xemThongTin' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'xemThongTin' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaClipboardList className="me-2" /> Xem thông tin đã nhập
                </Nav.Link>
              </Nav>
            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion Item 2 */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Chuyến Kinh Doanh</span>
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <Nav className="flex-column">
                <Nav.Link
                  className={`sidebar-link ${activeLink === 'taiXeNhanChuyen' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('taiXeNhanChuyen')}
                  style={{
                    color: activeLink === 'taiXeNhanChuyen' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'taiXeNhanChuyen' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaExchangeAlt className="me-2" /> Tài xế nhận chuyến
                </Nav.Link>
                <Nav.Link
                  className={`sidebar-link ${activeLink === 'chuyenKinhDoanh' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('chuyenKinhDoanh')}
                  style={{
                    color: activeLink === 'chuyenKinhDoanh' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'chuyenKinhDoanh' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaCheckCircle className="me-2" /> Chuyến kinh doanh hoàn tất
                </Nav.Link>
                {/* <Nav.Link
                  className={`sidebar-link ${activeLink === 'luongLaiXeKD' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('luongLaiXeKD')}
                  style={{
                    color: activeLink === 'luongLaiXeKD' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'luongLaiXeKD' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaTruck className="me-2" /> Lương lái xe KD
                </Nav.Link> */}
              </Nav>
            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion Item 3 */}
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Chuyến đi Bảo dưỡng - Sửa chữa</span>
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <Nav className="flex-column">
                <Nav.Link
                  className={`sidebar-link ${activeLink === 'chuyenBaoduongSuachua' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('chuyenBaoduongSuachua')}
                  style={{
                    color: activeLink === 'chuyenBaoduongSuachua' ? '#dc3545' : 'black',
                    padding: '10px 15px',
                    borderRadius: '50px',
                    backgroundColor: activeLink === 'chuyenBaoduongSuachua' ? '#f8d7da' : 'transparent',
                  }}
                >
                  <FaTools className="me-2" /> Bảo dưỡng - Sửa chữa
                </Nav.Link>
              </Nav>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};
export default NavbarComponent;
